// eslint-disable-next-line import/no-anonymous-default-export
export default {
  coeToDoWork: {
    entityTypeName: "Pending",
    name: "Work Order Name",
    introduction:
      "Show the list of all requirements submitted to the Automation Center of Excellence",
  },
};
